import React from 'react';
import { Button } from '@carnica/ui-kit';
import { IconSearchOutline } from '@carnica/graphics';
import { HeaderThemeView } from "../../../../../store/slices/layout";
import { Metric } from "../../../../../metric";
export var ButtonHeaderSearch = function ButtonHeaderSearch(_ref) {
  var headerTheme = _ref.headerTheme,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    data: "search",
    events: {
      headerMetric: ['handleTopIconClick']
    },
    mode: "click",
    "data-t-id": "Buttons-ButtonHeaderSearch"
  }, /*#__PURE__*/React.createElement(Button, {
    "aria-label": "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043F\u043E\u0438\u0441\u043A",
    iconRight: IconSearchOutline,
    onClick: onClick,
    onlyIcon: true,
    size: "m",
    type: "button",
    view: HeaderThemeView[headerTheme],
    "data-t-id": "Buttons-ButtonHeaderSearch"
  }));
};